export default function () {
  return [
    {
      ziff: 'VV2300',
      kurzbezeichnung: 'Geschäftsgebühr, §§ 2, 13, 14 RVG i.V.m. Nr. 2300 VV RVG',
      titel: 'Gebühr für die Prüfung der Erfolgsaussicht eines Rechtsmittels, soweit in Nummer 2102 nichts anderes bestimmt ist',
      type: 'fee',
      kommentar: 'Kommt später',
      Min: 0.5,
      Max: 2.5,
      isSetted: 1.3,
      sum: undefined,

    },
    {
      ziff: 'VV1008',
      kurzbezeichnung: 'Erhöhungsgebühr, 1008 VV RVG',
      titel: '',
      type: 'fee',
      kommentar: 'Kommt später',
      Min: 0.5,
      Max: 2.5,
      isSetted: 1.3,
      sum: undefined,
    },
    {
      ziff: 'VV1000',
      kurzbezeichnung: 'Einigungsgebühr, 1000 VV RVG',
      titel: 'Einigungsgeübhr',
      type: 'fee',
      kommentar: 'Kommt später',
      Min: 1.5,
      Max: 1.5,
      isSetted: 1.5,
      sum: undefined,
    },
    {
      ziff: 'VV7001,7002',
      kurzbezeichnung: 'Auslagen Nr. 7001, 7002 VV RVG',
      titel: 'Auslagen  ',
      type: 'amount',
      kommentar: 'Kommt später',
      Min: 0,
      Max: 50000,
      isSetted: 20,
      sum: 20,
    }];
}



// WEBPACK FOOTER //
// ./src/reducers/feeMatters.js